import PropTypes from "prop-types";
import { useMemo, useRef } from "react";

import {
  BaseCareerListItem,
  ComparingTag,
  HiddenTag,
  MatchTypeTag,
  SelectedTag,
} from "@features/ui";

import { useVisibilityCheck } from "@hooks/use-visibility-check";

import "./career-item.scss";

export const CareerItem = ({
  career,
  className,
  comparing,
  hidden,
  index,
  matchType,
  onClick,
  onVisibilityCheck,
  outOfFlow,
  selected,
}) => {
  const ref = useRef();

  useVisibilityCheck({ ref, initialRenderOnly: true, onVisibilityCheck });

  const tag = useMemo(() => {
    if (hidden) {
      return <HiddenTag key="hidden-tag" />;
    }
    if (selected) {
      return <SelectedTag key="selected-tag" />;
    }
    if (comparing) {
      return <ComparingTag key="comparing-tag" />;
    }
    if (matchType) {
      return <MatchTypeTag key="match-type-tag" type={matchType} />;
    }
  }, [comparing, matchType, selected, hidden]);

  const listItem = (
    <BaseCareerListItem
      ref={ref}
      index={index}
      className={className}
      onClick={() => onClick(career, index)}
      career={career}
      tags={tag}
    />
  );

  return outOfFlow ? <div className="out-of-flow">{listItem}</div> : listItem;
};

CareerItem.displayName = "Carrer Item";

CareerItem.propTypes = {
  career: PropTypes.object,
  className: PropTypes.string,
  comparing: PropTypes.bool,
  hidden: PropTypes.bool,
  index: PropTypes.number,
  matchType: PropTypes.oneOf(["exact", "related"]),
  onClick: PropTypes.func,
  onVisibilityCheck: PropTypes.func,
  outOfFlow: PropTypes.bool,
  selected: PropTypes.bool,
};
